<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>{{ $t("contact.heroTitle") }}</h1>
        <p>{{ $t("contact.heroSubtitle") }}</p>
      </div>
    </div>

    <div class="main-content">
      <div class="contact-container">
        <!-- 左侧联系信息 -->
        <div class="contact-info">
          <h2 class="contact-title">{{ $t("contact.contactInfo") }}</h2>

          <div v-if="loading" class="loading-text">{{ $t("notice.loading") }}</div>

          <template v-else>
            <div class="contact-item">
              <div class="contact-label">
                <Icon size="20" type="md-pin" />
                {{ $t("contact.address") }}
              </div>
              <p>{{ contactData.address }}</p>
            </div>

            <div class="contact-item">
              <div class="contact-label">
                <Icon size="20" type="md-mail" />
                {{ $t("contact.emailLabel") }}
              </div>
              <p>{{ contactData.email }}</p>
            </div>

            <div class="contact-item">
              <div class="contact-label">
                <Icon size="20" type="md-clock" />
                {{ $t("contact.officeHours") }}
              </div>
              <p>{{ contactData.weekdays }}</p>
              <p>{{ contactData.weekends }}</p>
            </div>

            <div class="contact-item">
              <div class="contact-label">
                <Icon size="20" type="md-bus" />
                {{ $t("contact.traffic") }}
              </div>
              <p>{{ contactData.subway }}</p>
              <p>{{ contactData.bus }}</p>
            </div>
          </template>
        </div>

        <!-- 右侧联系表单 -->
        <div class="contact-form">
          <h2 class="form-title">{{ $t("contact.sendMessage") }}</h2>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="name" class="form-label">{{
                $t("contact.formName")
              }}</label>
              <input
                type="text"
                id="name"
                v-model="form.name"
                class="form-input"
                required
              />
            </div>

            <div class="form-group">
              <label for="email" class="form-label">{{
                $t("contact.formEmail")
              }}</label>
              <input
                type="email"
                id="email"
                v-model="form.email"
                class="form-input"
                required
              />
            </div>

            <div class="form-group">
              <label for="phone" class="form-label">{{
                $t("contact.formPhone")
              }}</label>
              <input
                type="tel"
                id="phone"
                v-model="form.phone"
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label for="subject" class="form-label">{{
                $t("contact.formSubject")
              }}</label>
              <select
                id="subject"
                v-model="form.subject"
                class="form-input"
                required
              >
                <option value="">{{ $t("contact.selectSubject") }}</option>
                <option value="research">
                  {{ $t("contact.subjectResearch") }}
                </option>
                <option value="visit">{{ $t("contact.subjectVisit") }}</option>
                <option value="internship">
                  {{ $t("contact.subjectInternship") }}
                </option>
                <option value="admission">
                  {{ $t("contact.subjectAdmission") }}
                </option>
                <option value="other">{{ $t("contact.subjectOther") }}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="message" class="form-label">{{
                $t("contact.formMessage")
              }}</label>
              <textarea
                id="message"
                v-model="form.message"
                class="form-input form-textarea"
                required
              ></textarea>
            </div>

            <button type="submit" class="submit-btn" @click="sumbit()">
              {{ $t("contact.submitBtn") }}
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
// import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";

import { MessageAdd, getContactInfo } from "../../api/contact";

export default {
  name: "ContactUs",
  components: { Header, Nav, Footer },
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      },
      rawContactInfo: null,
      loading: true,
    };
  },
  computed: {
    // 根据当前语言环境返回对应的联系方式字段
    contactData() {
      if (!this.rawContactInfo) {
        return {};
      }
      const info = this.rawContactInfo;
      const isEn = this.$i18n.locale === "en";
      return {
        address: isEn ? (info.addressEn || info.addressZh) : info.addressZh,
        phone: isEn ? (info.phoneEn || info.phoneZh) : info.phoneZh,
        email: info.email,
        weekdays: isEn ? (info.weekdaysEn || info.weekdaysZh) : info.weekdaysZh,
        weekends: isEn ? (info.weekendsEn || info.weekendsZh) : info.weekendsZh,
        subway: isEn ? (info.subwayEn || info.subwayZh) : info.subwayZh,
        bus: isEn ? (info.busEn || info.busZh) : info.busZh,
      };
    },
  },
  created() {
    this.fetchContactInfo();
  },
  methods: {
    async fetchContactInfo() {
      try {
        let res = await getContactInfo();
        if (res.code === 0 && res.data) {
          this.rawContactInfo = res.data;
        }
      } catch (e) {
        console.log("获取联系方式失败", e);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      let res = await MessageAdd(this.form);
      if (res.code === 0) {
        alert(this.$t("contact.submitSuccess"));
      } else {
        console.log(res.error);
      }

      // 清空表单
      this.form = {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      };
    },
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 0 20px;
}

.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.1em;
}

.main-content {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.contact-container {
  display: flex;
  gap: 30px;
  justify-content: space-between;
}

.contact-info {
  width: 40%;
  background-color: #f8f9fa;
  padding: 30px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.contact-form {
  width: 60%;
  background-color: white;
  padding: 25px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.contact-info:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.contact-title {
  color: #004080;
  font-weight: 700;
  font-size: 1.4em;
  margin-top: 0;
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
  letter-spacing: 1px;
}

/* 联系信息项 */
.contact-item {
  margin-bottom: 20px;
  line-height: 1.6;
}

.loading-text {
  text-align: center;
  color: #999;
  padding: 40px 0;
  font-size: 0.95em;
}

.contact-label {
  display: block;
  font-weight: bold;
  color: #004080;
  min-width: 90px;
  font-size: 0.95em;
  margin-bottom: 5px;
}

.contact-label p {
  margin: 0 1rem;
}

.contact-label i {
  margin-right: 0.8rem;
}

.contact-icon {
  color: #004080;
  font-size: 1.2em;
  margin-right: 8px;
  width: 20px;
  text-align: center;
}

.contact-item p {
  margin: 0;
  color: #333;
  font-size: 0.95em;
  flex: 1;
}

.form-group {
  margin-bottom: 15px;
}

.form-title {
  color: #004080;
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #555;
}

.form-input,
.form-textarea,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.3s;
}

.form-textarea {
  min-height: 100px;
  resize: vertical;
}

.submit-btn {
  background-color: #004080;
  color: white;
  border: none;
  padding: 12px 25px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #003366;
}

/* ==================== 响应式调整 ==================== */
@media (max-width: 768px) {
  .contact-info {
    padding: 20px;
    border-radius: 8px;
  }

  .contact-title {
    font-size: 1.4rem;
    text-align: center;
  }

  .contact-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-label {
    min-width: auto;
  }
}
</style>
